// /home/labdoo/zitech-nexus/frontend/src/pages/MyApplications.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jobsAPI } from '../services/api';
import './MyApplications.css';

// SVG Icons
const Icons = {
  Briefcase: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Calendar: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  StatusDot: () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
      <circle cx="4" cy="4" r="4" />
    </svg>
  ),
  Empty: () => (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16v16H4z" />
      <line x1="8" y1="8" x2="16" y2="8" />
      <line x1="8" y1="12" x2="16" y2="12" />
      <line x1="8" y1="16" x2="12" y2="16" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ma-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  ArrowRight: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  X: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  View: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Download: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 17L12 21L20 17" />
      <path d="M12 3V15M12 15L8 11M12 15L16 11" />
    </svg>
  ),
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Pdf: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Image: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ),
  File: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  OpenNew: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  ),
};

interface Application {
  id: number;
  job_title: string;
  job: number;
  full_name: string;
  email: string;
  phone: string;
  status: string;
  applied_at: string;
  updated_at: string;
  account_created: boolean;
  user_email: string;
  resume?: string;
}

const MyApplications: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState<Application[]>([]);
  const [filter, setFilter] = useState('all');
  const [showFileViewer, setShowFileViewer] = useState(false);
  const [selectedFileUrl, setSelectedFileUrl] = useState('');
  const [selectedFileName, setSelectedFileName] = useState('');
  const [fileType, setFileType] = useState('');
  const [pdfLoadError, setPdfLoadError] = useState(false);

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const response = await jobsAPI.getUserApplications();
      setApplications(response.data);
    } catch (error) {
      console.error('Error fetching applications:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFileUrl = (filePath: string) => {
    if (!filePath) return '';
    if (filePath.startsWith('http')) return filePath;
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    return `${baseUrl}${filePath}`;
  };

  const getFileExtension = (fileName: string) => {
    return fileName.split('.').pop()?.toLowerCase() || '';
  };

  const isPdfFile = (fileName: string) => {
    return getFileExtension(fileName) === 'pdf';
  };

  const isImageFile = (fileName: string) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    return imageExtensions.includes(getFileExtension(fileName));
  };

  const openFileViewer = (fileUrl: string, fileName: string) => {
    setSelectedFileUrl(fileUrl);
    setSelectedFileName(fileName);
    setFileType(getFileExtension(fileName));
    setPdfLoadError(false);
    setShowFileViewer(true);
    document.body.style.overflow = 'hidden';
  };

  const closeFileViewer = () => {
    setShowFileViewer(false);
    setSelectedFileUrl('');
    setSelectedFileName('');
    setFileType('');
    setPdfLoadError(false);
    document.body.style.overflow = 'auto';
  };

  const handleDownload = (fileUrl: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handlePdfError = () => {
    setPdfLoadError(true);
  };

  const getStatusColor = (status: string) => {
    switch(status) {
      case 'pending': return '#f59e0b';
      case 'reviewed': return '#0ea5e9';
      case 'shortlisted': return '#8b5cf6';
      case 'interviewed': return '#06b6d4';
      case 'accepted': return '#10b981';
      case 'rejected': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusBackground = (status: string) => {
    switch(status) {
      case 'pending': return '#fef3c7';
      case 'reviewed': return '#dbeafe';
      case 'shortlisted': return '#ede9fe';
      case 'interviewed': return '#cffafe';
      case 'accepted': return '#d1fae5';
      case 'rejected': return '#fee2e2';
      default: return '#f3f4f6';
    }
  };

  const getStatusLabel = (status: string) => {
    switch(status) {
      case 'pending': return 'Pending Review';
      case 'reviewed': return 'Reviewed';
      case 'shortlisted': return 'Shortlisted';
      case 'interviewed': return 'Interviewed';
      case 'accepted': return 'Accepted';
      case 'rejected': return 'Rejected';
      default: return status;
    }
  };

  const getStatusIcon = (status: string) => {
    switch(status) {
      case 'accepted': return <Icons.Check />;
      case 'rejected': return <Icons.X />;
      default: return <Icons.StatusDot />;
    }
  };

  const filteredApplications = filter === 'all' 
    ? applications 
    : applications.filter(a => a.status === filter);

  const counts = {
    all: applications.length,
    pending: applications.filter(a => a.status === 'pending').length,
    reviewed: applications.filter(a => a.status === 'reviewed').length,
    shortlisted: applications.filter(a => a.status === 'shortlisted').length,
    interviewed: applications.filter(a => a.status === 'interviewed').length,
    accepted: applications.filter(a => a.status === 'accepted').length,
    rejected: applications.filter(a => a.status === 'rejected').length,
  };

  // File Viewer Full Page
  if (showFileViewer) {
    const isPdf = fileType === 'pdf';
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'].includes(fileType);
    
    return (
      <div className="ma-file-viewer-page">
        <div className="ma-file-viewer-header">
          <div className="ma-file-viewer-header-left">
            <button className="ma-file-viewer-back" onClick={closeFileViewer}>
              <Icons.Close />
              Back to Applications
            </button>
            <span className="ma-file-viewer-title">
              {isPdf ? <Icons.Pdf /> : isImage ? <Icons.Image /> : <Icons.File />}
              {selectedFileName}
            </span>
          </div>
          <div className="ma-file-viewer-header-actions">
            <button 
              className="ma-file-viewer-open"
              onClick={() => window.open(selectedFileUrl, '_blank')}
            >
              <Icons.OpenNew />
              Open in New Tab
            </button>
            <button 
              className="ma-file-viewer-download"
              onClick={() => handleDownload(selectedFileUrl, selectedFileName)}
            >
              <Icons.Download />
              Download
            </button>
          </div>
        </div>
        <div className="ma-file-viewer-body">
          {isPdf ? (
            <div className="ma-file-viewer-pdf-container">
              {!pdfLoadError ? (
                <embed
                  src={selectedFileUrl}
                  type="application/pdf"
                  className="ma-file-viewer-pdf"
                  onError={handlePdfError}
                />
              ) : null}
              {pdfLoadError && (
                <div className="ma-file-viewer-fallback">
                  <Icons.Pdf />
                  <p>Unable to display PDF directly.</p>
                  <div className="ma-file-viewer-fallback-actions">
                    <button 
                      className="ma-file-viewer-download-btn"
                      onClick={() => window.open(selectedFileUrl, '_blank')}
                    >
                      <Icons.OpenNew />
                      Open in New Tab
                    </button>
                    <button 
                      className="ma-file-viewer-download-btn"
                      onClick={() => handleDownload(selectedFileUrl, selectedFileName)}
                    >
                      <Icons.Download />
                      Download PDF
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : isImage ? (
            <div className="ma-file-viewer-image-container">
              <img 
                src={selectedFileUrl} 
                alt={selectedFileName} 
                className="ma-file-viewer-image"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  const parent = e.currentTarget.parentElement;
                  if (parent) {
                    const errorMsg = document.createElement('p');
                    errorMsg.className = 'ma-file-viewer-error';
                    errorMsg.textContent = 'Failed to load image. Please try downloading it instead.';
                    parent.appendChild(errorMsg);
                  }
                }}
              />
            </div>
          ) : (
            <div className="ma-file-viewer-placeholder">
              <Icons.File />
              <p>This file type cannot be previewed directly.</p>
              <button 
                className="ma-file-viewer-download-btn"
                onClick={() => handleDownload(selectedFileUrl, selectedFileName)}
              >
                <Icons.Download />
                Download File
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="ma-loading-container">
        <div className="ma-spinner">
          <Icons.Spinner />
        </div>
        <p className="ma-loading-text">Loading your applications...</p>
      </div>
    );
  }

  return (
    <div className="ma-container">
      {/* Header */}
      <div className="ma-header">
        <div className="ma-header-left">
          <h1 className="ma-title">My Applications</h1>
          <p className="ma-subtitle">Track the status of your job applications</p>
        </div>
        <button 
          className="ma-btn-primary"
          onClick={() => navigate('/careers')}
        >
          <Icons.Briefcase />
          Browse Jobs
        </button>
      </div>

      {/* Stats Bar */}
      <div className="ma-stats-bar">
        <div className="ma-stat-item">
          <span className="ma-stat-label">Total Applications</span>
          <span className="ma-stat-value">{counts.all}</span>
        </div>
        <div className="ma-stat-divider"></div>
        <div className="ma-stat-item">
          <span className="ma-stat-label">Pending</span>
          <span className="ma-stat-value ma-stat-pending">{counts.pending}</span>
        </div>
        <div className="ma-stat-divider"></div>
        <div className="ma-stat-item">
          <span className="ma-stat-label">Reviewed</span>
          <span className="ma-stat-value ma-stat-reviewed">{counts.reviewed}</span>
        </div>
        <div className="ma-stat-divider"></div>
        <div className="ma-stat-item">
          <span className="ma-stat-label">Shortlisted</span>
          <span className="ma-stat-value ma-stat-shortlisted">{counts.shortlisted}</span>
        </div>
        <div className="ma-stat-divider"></div>
        <div className="ma-stat-item">
          <span className="ma-stat-label">Accepted</span>
          <span className="ma-stat-value ma-stat-accepted">{counts.accepted}</span>
        </div>
      </div>

      {/* Filters */}
      <div className="ma-filters">
        <button 
          className={`ma-filter-btn ${filter === 'all' ? 'ma-filter-active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All
          <span className="ma-filter-count">{counts.all}</span>
        </button>
        <button 
          className={`ma-filter-btn ${filter === 'pending' ? 'ma-filter-active' : ''}`}
          onClick={() => setFilter('pending')}
        >
          Pending
          <span className="ma-filter-count">{counts.pending}</span>
        </button>
        <button 
          className={`ma-filter-btn ${filter === 'reviewed' ? 'ma-filter-active' : ''}`}
          onClick={() => setFilter('reviewed')}
        >
          Reviewed
          <span className="ma-filter-count">{counts.reviewed}</span>
        </button>
        <button 
          className={`ma-filter-btn ${filter === 'shortlisted' ? 'ma-filter-active' : ''}`}
          onClick={() => setFilter('shortlisted')}
        >
          Shortlisted
          <span className="ma-filter-count">{counts.shortlisted}</span>
        </button>
        <button 
          className={`ma-filter-btn ${filter === 'interviewed' ? 'ma-filter-active' : ''}`}
          onClick={() => setFilter('interviewed')}
        >
          Interviewed
          <span className="ma-filter-count">{counts.interviewed}</span>
        </button>
        <button 
          className={`ma-filter-btn ${filter === 'accepted' ? 'ma-filter-active' : ''}`}
          onClick={() => setFilter('accepted')}
        >
          Accepted
          <span className="ma-filter-count">{counts.accepted}</span>
        </button>
        <button 
          className={`ma-filter-btn ${filter === 'rejected' ? 'ma-filter-active' : ''}`}
          onClick={() => setFilter('rejected')}
        >
          Rejected
          <span className="ma-filter-count">{counts.rejected}</span>
        </button>
      </div>

      {/* Table - Line Based Design */}
      <div className="ma-table-wrapper">
        {filteredApplications.length === 0 ? (
          <div className="ma-empty-state">
            <Icons.Empty />
            <h3 className="ma-empty-title">No Applications Found</h3>
            <p className="ma-empty-text">
              {filter === 'all' 
                ? "You haven't applied to any jobs yet. Start your career journey today!"
                : `You don't have any ${filter} applications.`}
            </p>
            <button className="ma-btn-primary" onClick={() => navigate('/careers')}>
              <Icons.Briefcase />
              Browse Jobs
            </button>
          </div>
        ) : (
          <table className="ma-table">
            <thead>
              <tr>
                <th className="ma-col-sn">#</th>
                <th className="ma-col-job">Job Title</th>
                <th className="ma-col-status">Status</th>
                <th className="ma-col-applied">Applied Date</th>
                <th className="ma-col-updated">Last Updated</th>
                <th className="ma-col-resume">Resume</th>
                <th className="ma-col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredApplications.map((application, index) => {
                const resumeFileName = application.resume?.split('/').pop() || '';
                const resumeUrl = application.resume ? getFileUrl(application.resume) : '';
                const isPdf = resumeFileName ? isPdfFile(resumeFileName) : false;
                const isImage = resumeFileName ? isImageFile(resumeFileName) : false;
                
                return (
                  <tr key={application.id} className="ma-table-row">
                    <td className="ma-col-sn">
                      <span className="ma-sn">{index + 1}</span>
                    </td>
                    <td className="ma-col-job">
                      <span className="ma-job-title">{application.job_title}</span>
                      <span className="ma-job-id">#{application.id}</span>
                    </td>
                    <td className="ma-col-status">
                      <span 
                        className="ma-status-badge"
                        style={{
                          background: getStatusBackground(application.status),
                          color: getStatusColor(application.status)
                        }}
                      >
                        {getStatusIcon(application.status)}
                        {getStatusLabel(application.status)}
                      </span>
                    </td>
                    <td className="ma-col-applied">
                      <span className="ma-date-text">
                        <Icons.Calendar />
                        {new Date(application.applied_at).toLocaleDateString('en-US', { 
                          month: 'short', 
                          day: 'numeric', 
                          year: 'numeric' 
                        })}
                      </span>
                    </td>
                    <td className="ma-col-updated">
                      <span className="ma-date-text">
                        <Icons.Calendar />
                        {new Date(application.updated_at).toLocaleDateString('en-US', { 
                          month: 'short', 
                          day: 'numeric', 
                          year: 'numeric' 
                        })}
                      </span>
                    </td>
                    <td className="ma-col-resume">
                      {resumeUrl ? (
                        <div className="ma-resume-actions">
                          {(isPdf || isImage) && (
                            <button 
                              className="ma-resume-view"
                              onClick={() => openFileViewer(resumeUrl, resumeFileName)}
                              title="View Resume"
                            >
                              <Icons.View />
                            </button>
                          )}
                          <button 
                            className="ma-resume-download"
                            onClick={() => handleDownload(resumeUrl, resumeFileName)}
                            title="Download Resume"
                          >
                            <Icons.Download />
                          </button>
                          <span className="ma-resume-name">{resumeFileName}</span>
                        </div>
                      ) : (
                        <span className="ma-no-resume">—</span>
                      )}
                    </td>
                    <td className="ma-col-actions">
                      <button 
                        className="ma-action-btn"
                        onClick={() => navigate(`/jobs/${application.job}`)}
                      >
                        View Job
                        <Icons.ArrowRight />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default MyApplications;